export const business = {
  name: "Post Bail Bonds Inc.",
  tagline: "Bail with Respect",
  phoneDisplay: "702-384-7777",
  phoneHref: "tel:7023847777",
  phoneE164: "+1-702-384-7777",
  street: "2917 S Sammy Davis Jr Dr",
  cityLine: "Las Vegas, NV 89109",
  address: "2917 S Sammy Davis Jr Dr, Las Vegas, NV 89109",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=2917+S+Sammy+Davis+Jr+Dr+Las+Vegas+NV+89109",
  directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=2917+S+Sammy+Davis+Jr+Dr+Las+Vegas+NV+89109",
  mapsEmbed: "https://www.google.com/maps?q=2917+S+Sammy+Davis+Jr+Dr,+Las+Vegas,+NV+89109&output=embed",
  payUrl:
    "https://secure2.procharge.com/YouPay/View/Youpay.dll?p=DVTfHYH4INR6B99ni6eLPA==&z=Kp/IMmPKR1+E2knEwF1ihA==&a=",
  facebookUrl: "https://www.facebook.com/profile.php?id=100067055832190",
  googleReviewsUrl: "https://www.google.com/search?q=Post+Bail+Bonds+Inc+Las+Vegas+reviews",
  license: "[[FILL IN]]",
  googleRating: "[[FILL IN]]",
};

export const routes = {
  home: "/",
  services: "/las-vegas-bail-bonds-fast-confidential-24-7-services/",
  getBond: "/las-vegas-bail-bonds/",
  resources: "/nevada-inmate-resources-legal-support-bail-bonds-court-information/",
  about: "/about/",
  contact: "/contact-post-bail-bonds-las-vegas/",
  blog: "/blog/",
};

export const navLinks = [
  { label: "Home", to: routes.home },
  { label: "Services", to: routes.services },
  { label: "Get Your Bail Bond Now", to: routes.getBond },
  { label: "Resources", to: routes.resources },
  { label: "About", to: routes.about },
  { label: "Contact", to: routes.contact },
];

export const quickLinks = [
  { label: "Find an Inmate", to: `${routes.getBond}#find-inmate` },
  { label: "Bail Calculator", to: `${routes.getBond}#calculator` },
  { label: "Pay Online", to: `${routes.getBond}#pay` },
  { label: "Download Bail Forms", to: `${routes.getBond}#forms` },
];

export const jailOptions = [
  "Clark County Detention Center",
  "Las Vegas City Jail",
  "North Las Vegas Jail",
  "Henderson Detention Center",
  "Other",
  "Not Sure",
];
